import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material';
import {Location} from '@angular/common';

@Component({
  selector: 'app-not-support',
  templateUrl: './not-support.component.html',
  styleUrls: ['./not-support.component.css']
})
export class NotSupportComponent implements OnInit {

  constructor(private router: Router, private http: HttpClient,
              private route: ActivatedRoute, private snackBar: MatSnackBar, public location: Location) {
    route.params.subscribe(params => {
      this.snackBar.open('Sorry, this provider/route is not supported: ' +
        this.location.path().replace('/', ' '), 'Dismiss', {duration: 10000});
      this.router.navigate(['/']);
    });
  }

  ngOnInit() {
  }

}
